import { useEffect, useState } from "react";
import { api } from "../App";
import { formatMoney } from "../lib/currency";

export default function FXPreview({ amount, currency, targets, date, rates = {}, onRatesChange }) {
  const [quotes, setQuotes] = useState({});
  const key = [...new Set(targets.filter(c => c && c !== currency))].join(",");
  useEffect(() => {
    let active = true;
    setQuotes({});
    if (!currency || !key) return;
    Promise.all(key.split(",").map(async target => {
      try { const { data } = await api.get("/fx/quote", { params: { base: currency, target, date: date || undefined } }); return [target, data]; }
      catch { return [target, { unavailable: true }]; }
    })).then(entries => { if (active) setQuotes(Object.fromEntries(entries)); });
    return () => { active = false; };
  }, [currency, key, date]);
  if (!key) return null;
  return <div className="rounded-xl bg-slate-50 dark:bg-slate-800 p-3 w-full text-xs space-y-2">
    <p>Conversión estimada para la fecha del movimiento</p>
    {key.split(",").map(target => {
      const quote = quotes[target];
      const rate = rates[target] || quote?.rate;
      return <div key={target} className="space-y-1">
        <p>{rate ? `≈ ${target} ${formatMoney(Number(amount || 0) * rate, target, { style: "decimal" })} · 1 ${currency} = ${rate} ${target}` : quote?.unavailable ? `Tasa ${currency}/${target} no disponible. Indica una tasa o inténtalo después.` : "Consultando tasa…"}</p>
        {quote?.date && !rates[target] && <p>{quote.date} · {quote.source}</p>}
        {onRatesChange && <label className="block">Tasa manual {currency} → {target} (opcional)
          <input className="block rounded border px-2 py-1 w-full" type="number" step="any" min="0.00000001" aria-label={`Tasa manual ${currency} a ${target}`} value={rates[target] || ""} onChange={e => onRatesChange({ ...rates, [target]: e.target.value ? Number(e.target.value) : undefined })} />
        </label>}
      </div>;
    })}
  </div>;
}
